export const getSecondsToDate = (endDate?: string) => {
    const minTime = 0; // 1 second
    const maxTime = 60 * 60 - 1; // 1 hour
    const now = new Date();
    const parsed = endDate ? new Date(endDate).getTime() : NaN;
    // A missing or unparseable endDate falls back to one minute; NaN would freeze the timer on "NaN:NaN".
    const date = Number.isNaN(parsed) ? now.setMinutes(now.getMinutes() + 1) : parsed;
    const calculatedSeconds = Math.ceil((date - Date.now()) / 1000);
    return Math.max(minTime, Math.min(calculatedSeconds, maxTime));
};
